export default {
  Form: {
    buttonOK: "OK",
    buttonClear: 'Clear',
    required: "Vui lòng nhập đầy đủ thông tin",
    min: "Vui lòng nhập giá trị nhỏ nhất là $arguments[0]",
    max: "Vui lòng nhập giá trị lớn nhất là $arguments[0]",
    minLength: "Vui lòng nhập tối thiểu $arguments[0] ký tự",
    maxLength: "Vui lòng nhập tối đa $arguments[0] ký tự",
    lessThan: "Vui lòng nhập giá trị nhỏ hơn $arguments[0]",
    greatherThan: "Vui lòng nhập giá trị lớn hơn $arguments[0]",
    incorrectPassword: "Tài khoản hoặc mật khẩu không chính xác. Nếu bạn đã quên thông tin, vui lòng liên hệ quản trị viên để được trợ giúp.",
  },
  Input: {
    code: "Mã nhân viên",
    account: "Tài khoản",
    username: "Tên nhân viên",
    phonenumber: "Số điện thoại",
    group: "Nhóm",
    area: "Khu vực",
    password: "Mật khẩu",
    rePassword: "Nhập lại mật khẩu"
  },
  Button: {
    addUser: "Tạo nhân viên"
  },
  Sidebar: {
    user: "Người dùng",
    role: "Vai Trò"
  },
  Breadcrumb: {
    userIndex: "Danh sách người dùng",
    userCreate: "Thêm mới người dùng",
    roleIndex: "Vai trò"
  },
  User: {
    username: "Tài khoản",
    password: "Mật khẩu",
    remember: "Ghi nhớ tài khoản",
    signin: "Đăng nhập"
  }
}